import React, { Fragment } from "react";
import { IoIosCalendar } from "react-icons/io";
import PerfectScrollbar from "react-perfect-scrollbar";

import {
  DropdownToggle,
  DropdownMenu,
  Nav,
  Col,
  Row,
  Button,
  NavItem,
  NavLink,
  UncontrolledTooltip,
  UncontrolledButtonDropdown,
} from "reactstrap";

import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'react-toastify/dist/ReactToastify.css';
import city3 from "../../../assets/utils/images/dropdown-header/city3.jpg";
import { connect } from 'react-redux';
import { doSignOut } from "../../../store/AuthSlice.tsx";
import { Navigate } from 'react-router-dom';
import { userDetail } from '../../../security/LoginDetail.js';

const authStateToProps = (state) => ({    
  isAuthenticated : state.auth.isAuthenticated,
  user : state.auth.user,
  error  : state.auth.error,
  status : state.auth.authStatus,
});

class UserBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  handleSignOut = e => {
    this.props.signOut(); 
  };

  render() {    
    if (userDetail === null) return;

    if (this.props.status == 'logout'){
      return <Navigate to="/SignIn" replace={true} />;
    }
    return (
      <Fragment>
        <div className="header-btn-lg pe-0">
          <div className="widget-content p-0">
            <div className="widget-content-wrapper">
              <div className="widget-content-left">
                <UncontrolledButtonDropdown>
                  <DropdownToggle color="link" className="p-0">
                    {/* <img width={42} className="rounded-circle" src={avatar1} alt=""/> */}
                      <AvatarPerson />
                    <FontAwesomeIcon
                      className="ms-2 opacity-8"
                      icon={faAngleDown}
                    />
                  </DropdownToggle>
                  <DropdownMenu className="rm-pointers dropdown-menu-lg">
                    <div className="dropdown-menu-header">
                      <div className="dropdown-menu-header-inner bg-info">
                        <div className="menu-header-image opacity-2"
                          style={{
                            backgroundImage: "url(" + city3 + ")",
                          }}/>
                        <div className="menu-header-content text-start">
                          <div className="widget-content p-0">
                            <div className="widget-content-wrapper">
                              <div className="widget-content-left me-3">
                                {/* <img width={42} className="rounded-circle" src={avatar1} alt=""/> */}
                                <AvatarPerson />
                              </div>
                              <div className="widget-content-left">
                                <div className="widget-heading">
                                  {userDetail.DisplayName}
                                </div>
                                {/* <div className="widget-subheading opacity-8">
                                  A short profile description
                                </div> */}
                              </div>
                              <div className="widget-content-right me-2">
                                <Button className="btn-pill btn-shadow btn-shine" color="focus" onClick={this.handleSignOut}>
                                  Logout
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="scroll-area-xs"
                      style={{
                        height: "80px",
                      }}>
                      <PerfectScrollbar>
                        <Nav vertical>
                          <NavItem className="nav-item-header">
                            Activity
                          </NavItem>
                          <NavItem>
                            <NavLink href="#">Recover Password</NavLink>
                          </NavItem>
                          <NavItem className="nav-item-header">
                            My Account
                          </NavItem>
                          <NavItem>
                            <NavLink href="#">
                              Settings
                              <div className="ms-auto badge bg-success">
                                New
                              </div>
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </PerfectScrollbar>
                    </div> */}
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </div>
              <div className="widget-content-left  ms-3 header-user-info">
                <div className="widget-heading">{userDetail.DisplayName}</div>
                {/* <div className="widget-subheading">VP People Manager</div> */}
              </div>
              {/* <div className="widget-content-right header-user-info ms-3">
                <Button className="btn-shadow p-1" size="sm" onClick={this.notify2} color="info" id="Tooltip-1">
                  <IoIosCalendar color="#ffffff" fontSize="20px" />
                </Button>
                <UncontrolledTooltip placement="bottom" target={"Tooltip-1"}>
                  Click for Toastify Notifications!
                </UncontrolledTooltip>
              </div> */}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const AvatarPerson = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
      <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
      <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
    </svg>
  );
}

// export default UserBox;

const mapDispatchToProps = (dispatch) => ({
  signOut: () => dispatch(doSignOut()),
});

export default connect(authStateToProps, mapDispatchToProps)(UserBox);